/// <reference path="../Helpers.js"/>
/// <reference path="../GeneralSettings.js"/>

(function (sb) {
    var myStory;
    sb.MyStory = (sb.MyStory || {});
    sb.MyStory.InitializeMyStory = initializeMyStory;

    function initializeMyStory() {
        var params = {
            method: 'GetMyStory',
            message: 'Loading...',
            data: {
            },
            successCallback: function (result) {
                myStory = JSON.parse(result);
            },
            service: 'MyStory'
        }

        Helpers.perfJSonCall(params);
        initializeEvents();
    }

    function initializeEvents() {

        $('#btnMyStory').click(function () {
            if (Storyboard.GeneralSettings.storyBoardAccess.MyStories) {
                displayMyStoryPopUp();
            }
        });

        $('#btnAddMyStoryFolder').live('click', function () {
            displaySaveMyStoryFolderPopUp();
        });

        $('#btnAddMyStorySlide').live('click', function () {
            displaySaveMyStorySlidePopUp();
        });

        $('#btnUpdateMyStorySlidePositions').live('click', function () {
            updateSlidePositionsInMyStory();
        });

        $('#textMyStorySearch').live('keyup', function () {

            var filter = $(this).val().toLowerCase();

            $('.myStorySlide').each(function () {
                if ($(this).attr('slidename').toLowerCase().lastIndexOf(filter) > -1) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            });
        });

        $('.imgDeleteMyStorySlide').live('click', function (e) {
            e.stopPropagation();
            var slideID = $(this).closest('.myStorySlide').attr('slideID');
            var execOnConfirm = partial(deleteSlideFromMyStoryFolder, slideID);
            displayConfirmationPopup('Do you want to delete this slide?', execOnConfirm);
        });

        $('.imgDeleteMyStoryFolder').live('click', function (e) {            
            var folderID = $(this).attr('folderID');
            var execOnConfirm = partial(deleteFolderFromMyStory, folderID);
            displayConfirmationPopup('Do you want to delete this folder?', execOnConfirm);
        });

        $('.imgCopyMyStorySlideToFolder').live('click', function (e) {
            var slideID = $(this).closest('.myStorySlide').attr('slideID');
            displayMoveSlideToMyStoryFolderPopUp(slideID);
            e.stopPropagation();
        });

        $('.imgRenameMyStorySlide').live('click', function (e) {
            var slideID = $(this).closest('.myStorySlide').attr('slideID');
            displayRenameMyStorySlidePopUp(slideID);
            e.stopPropagation();
        });

        $('.imgRenameMyStoryFolder').live('click', function () {
            var folderID = $(this).attr('folderID');            
            displayRenameMyStoryFolderPopUp(folderID);
        });

        $('.myStorySlide').live({
            mouseenter: function () {
                var miniToolbar = '<div id="myStorySlideMiniToolbar">' +
                                    '<button type="button" class="imgCopyMyStorySlideToFolder linkButton" title="Copy slide to folder"><i class="DUI-icon DUI-icon-copy"></i></button>'+
                                    '<button type="button" class="imgRenameMyStorySlide linkButton" title="Rename My Story slide"><i class="DUI-icon DUI-icon-edit"></i></button>'+
                                    '<button type="button" class="imgDeleteMyStorySlide linkButton" title="Delete My Story slide"><i class="DUI-icon DUI-icon-close"></i></button>'+
                                    '</div>';
                $(this).append(miniToolbar);
                $(this).find('#myStorySlideMiniToolbar').fadeIn(400);
            },
            mouseleave: function () {
                $(this).find('#myStorySlideMiniToolbar').fadeOut(400).remove();
            }
        });

         $('.myStorySlide').live('click', function () {
            if ($(this).hasClass('myStorySlideNotSelected')) {
                $(this).removeClass('myStorySlideNotSelected').
                    addClass('myStorySlideSelected');
            } else {
                $(this).removeClass('myStorySlideSelected').
                    addClass('myStorySlideNotSelected');
            }

            $(this).closest('.myStoryFolder').find('.myStorySlide').
                not('[layouttype="' + $(this).attr('layouttype') + '"]').
                removeClass('myStorySlideSelected').addClass('myStorySlideNotSelected');

            if ($(this).attr('layouttype') !== "1") {
                $(this).siblings().removeClass('myStorySlideSelected').
                        addClass('myStorySlideNotSelected');
            }

            handleInputElementsVisibility();
        });

        $('.selectAllMyStorySlides input').live('click', function () {
            var selectAllChecked = $(this).is(':checked');

            $(this).closest('.myStoryFolder').find('.myStorySlide').each(function () {
                if (selectAllChecked) {
                    $(this).removeClass("myStorySlideNotSelected").
                    addClass('myStorySlideSelected');
                } else {
                    $(this).removeClass("myStorySlideSelected").
                        addClass('myStorySlideNotSelected');
                }
            });
            handleInputElementsVisibility();
        });
    }

    function displayMyStoryPopUp() {

        var html = '';

        html += '<div class="myStoryButtons">';
        html += '<input id="btnAddMyStoryFolder" type="button" class="linkButton addNew" value="' + locale.get('Add Folder') + '"/>';
        html += '<input id="btnAddMyStorySlide" type="button" class="linkButton addNew" value="' + locale.get('Add Slide') + '"/>';
        html += '</div>';
        html += '<div id="myStoryPopupPlaceholder"></div>';

        new DUIwindow2({
            title: locale.get('My Stories'),
            width: 510,
            padding: 45,
            buttonsHeight: 50,
            buttons: [
                {
                    buttonId: 'btnMyStoryGeneratePPT',
                    text: locale.get('Generate PPT report'),
                    onClick: function (e) {
                        downloadMyStoryExport('PowerPoint', 'PPT', 'QueuePPTPDFExport');
                        e.stopPropagation();
                    }
                },
                {
                    buttonId: 'btnMyStoryGenerateExcel',
                    text: locale.get('Generate Excel report'),
                    onClick: function (e) {
                        downloadMyStoryExport('Excel', 'Excel', 'QueueExcelExport');
                        e.stopPropagation();
                    }
                },
                {
                    buttonId: 'btnMyStoryViewSlides',
                    text: locale.get('View'),
                    onClick: function (e) {
                        openSelectedMyStorySlidesInNewWindow();
                    }
                }
            ],
            html: html,
            modal: true,
            preWrapSpace: false
        });

        drawMyStoryAccordion();
        handleInputElementsVisibility();
    }

    function drawMyStoryAccordion() {
              
        var html = '';

        if (myStory) {                                   
            if (Storyboard.HFilterLayout.hasHFilterNodes()) {
                html += '<div id="hFilterTreeMyStory" class="floatLeft m-1-0"></div>';
                html += '<div class="floatLeft m-1"><label for="chkMyStorySplitFilter"><span>' +
                    locale.get("SplitFilters") + '</span></label>' +
                    '<input id="chkMyStorySplitFilter" type="checkbox"/></div>';
            }

            html += '<div class="m-1-0"><input id="textMyStorySearch" class="searchbox textbox fullInput"></div>';
            html += '<div id="accordionMyStory">';
            html += createHTMLForMyStoryAccordionPanels();
            html += '</div>';            
            html += '<div id="myStoryExportedFiles" class="m-1-0"></div>';

            var activePanel = $('#accordionMyStory').accordion('option', 'active');
            
            if (!activePanel || isNaN(activePanel)) {
                activePanel = 0;
            }

            $('#myStoryPopupPlaceholder').empty().append(html);

            if (Storyboard.HFilterLayout.hasHFilterNodes()) {
                switch (Storyboard.LayoutDesigner.getHFilterLayout()) {
                    case 3:
                    case 4:
                        $('#hFilterTreeMyStory').hFilterControl('tree');
                        break;
                    case 1:
                    case 2:
                    default:
                        $('#hFilterTreeMyStory').hFilterControl('listBox');
                        break;
                }
            }
           
            $('#accordionMyStory').accordion({
                active: activePanel,
                autoHeight: false,
                collapsible: true,
                change: function (event, ui) { handleInputElementsVisibility(); }
            });

            makeElementAsDragAndDrop();
        }

        handleInputElementsVisibility();
    }

    function createHTMLForMyStoryAccordionPanels() {

        var html = '';
        var folders = myStory.Folders;
        folders.sort(SortByFolderID);

        for (var i = 0; i < folders.length; i++) {
            var folderID = folders[i].MyStoryFolderID;
            var folderName = HTMLHelpers.htmlEncode(folders[i].Name);
            html += '<h3 class="myStoryFolderTitle">' + folderName +
                       '<div class="myStoryFolderButtons">' +
                       '<button type="button" class="imgRenameMyStoryFolder linkButton" title="Rename Folder" folderID="' + folderID + '"><i class="DUI-icon DUI-icon-edit"></i></button>'+
                       '<button type="button" class="imgDeleteMyStoryFolder linkButton" title="Delete Folder" folderID="' + folderID + '"><i class="DUI-icon DUI-icon-close"></i></button>' +
                       '</div>' +
                    '</h3>' +
                    '<div class="myStoryFolder" folderID="' + folderID +
                        '" panelIndex="' + i + '">';

            var slides = folders[i].Slides;
            slides.sort(SortByPosition);

            html += createHTMLForMyStorySlides(slides);

            html += '<div class="myStoryFolderButtons">';           
            html += '</div></div>'
        }
        return html;
    }

    function createHTMLForMyStorySlides(slides) {

        var pptSlidesHTML = '<div class="myStoryPPTSlides myStorySlideType">' +
            '<label class="myStoryLayoutTypeLabel">PowerPoint</label><div class="myStorySortable cf">';
        var portraitSlidesHTML = '<div class="myStoryPortraitSlides myStorySlideType">' +
            '<label class="myStoryLayoutTypeLabel">A4 Portrait</label><div class="myStorySortable cf">';
        var landscapeSlidesHTML = '<div class="myStoryLandscapeSlides myStorySlideType">' +
            '<label class="myStoryLayoutTypeLabel">Landscape</label><div class="myStorySortable cf">';

        var showPPT = false; var showPortrait = false; var showLandscape = false;
        var html = '';

        for (var i = 0; i < slides.length; i++) {
            var slide = slides[i];
            if (slide.LayoutType === 1) {
                pptSlidesHTML += createHTMLForMyStorySlide(slide);
                showPPT = true;
            } else if (slide.LayoutType === 2) {
                portraitSlidesHTML += createHTMLForMyStorySlide(slide);
                showPortrait = true;
            } else if (slide.LayoutType === 3) {
                landscapeSlidesHTML += createHTMLForMyStorySlide(slide);
                showLandscape = true;
            } else {
                slide.LayoutType = 1;
                pptSlidesHTML += createHTMLForMyStorySlide(slide);
                showPPT = true;
            }
        }

        if (showPPT) {
            pptSlidesHTML += '</div></div>'
            html += pptSlidesHTML;
        }

        if (showPortrait) {
            portraitSlidesHTML += '</div></div>'
            html += portraitSlidesHTML;
        }

        if (showLandscape) {
            landscapeSlidesHTML += '</div></div>';
            html += landscapeSlidesHTML;
        }

        if (showPPT + showPortrait + showLandscape === 1) {            
            html = $(html).find('.myStoryLayoutTypeLabel').remove().end().html();
            html = '<div class="selectAllMyStorySlides"><label><input type="checkbox"/>' + locale.get("Select all") + ' </label></div>' + html;
        }

        return html;
    }

    function createHTMLForMyStorySlide(slide) {

        var slideID = slide.MyStorySlideID;
        var slideName = slide.Name;

        var html = '<div class="myStorySlide myStorySlideNotSelected"' +
                        'layoutType="' + slide.LayoutType + '"' +
                        '" slideID="' + slideID + '" slidename="' + slideName + '">' +
                    '<div class="myStorySlideLabel">' + HTMLHelpers.htmlEncode(slideName) + '</div>' +
                    '</div>';

        return html;
    }

    function makeElementAsDragAndDrop() {

        $('.myStorySortable').sortable('destroy').sortable({
            items: '> .myStorySlide',
            revert: 'invalid',
            tolerance: 'pointer',
            helper: 'clone',
            containment: '#accordionMyStory',
            update: function () {
                updateSlidePositionsInMyStory();
            }
        });
        $(".myStorySortable").disableSelection();
    }

    function handleInputElementsVisibility() {

        if (!myStory) {
            $('#btnMyStoryGeneratePPT, #btnMyStoryGenerateExcel, #btnMyStoryViewSlides,' +
                '#btnAddMyStorySlide').attr('disabled', 'disabled');
        } else {
            if ($('.ui-accordion-content-active .myStorySlideSelected[layouttype ="1"]').length < 1) {
                $('#btnMyStoryGeneratePPT').attr('disabled', 'disabled');
            } else {
                $('#btnMyStoryGeneratePPT').removeAttr('disabled');
            }

            if ($('.ui-accordion-content-active .myStorySlideSelected').length < 1) {
                $('#btnMyStoryGenerateExcel').attr('disabled', 'disabled');
                $('#btnMyStoryViewSlides').attr('disabled', 'disabled');
            } else {
                $('#btnMyStoryGenerateExcel').removeAttr('disabled');
                $('#btnMyStoryViewSlides').removeAttr('disabled');
            }

            if (myStory.Folders.length < 1) {
                $('#btnAddMyStorySlide').attr('disabled', 'disabled');
            } else {
                $('#btnAddMyStorySlide').removeAttr('disabled');
            }

            if ($('.myStorySlide').length < 1) {
                $('#textMyStorySearch').hide();
                $('#hFilterTreeMyStory').next().hide();
                $('#hFilterTreeMyStory').hide();
            } else {
                $('#textMyStorySearch').show();
                $('#hFilterTreeMyStory').show();
                $('#hFilterTreeMyStory').next().show();
            }
        }
    }

    function displaySaveMyStoryFolderPopUp() {
        new DUIwindow2({
            title: '<h2>'+locale.get('Add new folder')+'</h2>',
            width: 400,
            padding: 36,
            buttonsHeight: 50,
            buttons: [
                {
                    text: locale.get('Cancel'),
                    onClick: function () {
                        return false;
                    }
                },
                {
                    text: locale.get('Save'),
                    focused: true,
                    onClick: function (event) {
                        var folderName = $('#myStoryFolderName').val();
                        if (folderName.length > 0) {
                            saveFolderToMyStory(folderName);
                        } else {
                            $('#myStoryFolderName').css('border-color', '#e5a0b2').focus();
                            event.stopPropagation();
                        }
                    }
                }
            ],
            html: '<div class="settingItem"><label for="myStoryFolderName" class="settingLabel">' + locale.get('Folder name') + ':</label>' +
                    '<input id="myStoryFolderName" class="settingControl textbox"></input>' +
                    '</div>',
            modal: true,
            preWrapSpace: false,
            afterShow: function () {
                $('#myStoryFolderName').focus();
            }
        });
    }

    function displaySaveMyStorySlidePopUp() {

        var html = '<label id="lblSelectMyStoryFolder" class="settingLabel">' + locale.get('Select folder') + ':</label><select id="ddlMyStoryFolders" class="settingControl">';
        var options = '';

        for (var i = 0; i < myStory.Folders.length; i++) {
            options += '<option value="' + myStory.Folders[i].MyStoryFolderID + '">' + HTMLHelpers.htmlEncode(myStory.Folders[i].Name) + '</option>';
        }

        html += options;
        html += '</select>';

        html += '<div class="settingItem"><label for="myStorySlideName" class="settingLabel">' + locale.get('Slide name') + ':</label>' +
                    '<input id="myStorySlideName" class="settingControl textbox"></input>' +
                '</div>'

        new DUIwindow2({
            title: '<h2>' + locale.get('Add new slide') + '</h2>',
            width: 400,
            padding: 36,
            buttonsHeight: 50,
            buttons: [
                {
                    text: locale.get('Cancel'),
                    onClick: function () {
                        return false;
                    }
                },
                {
                    text: locale.get('Save'),
                    focused: true,
                    onClick: function (event) {
                        var slideName = $('#myStorySlideName').val();
                        var folderID = $('#ddlMyStoryFolders option:selected').val();

                        if (slideName.length > 0) {
                            saveSlideToMyStoryFolder(slideName, folderID);
                        } else {
                            $('#myStorySlideName').css('border-color', '#e5a0b2').focus();
                            event.stopPropagation();
                        }
                    }
                }
            ],
            html: html,
            modal: true,
            preWrapSpace: false,
            afterShow: function () {
                $('#myStorySlideName').focus();
            }
        });

        var activeFolderID = $('.ui-accordion-content-active').attr('folderID');
        $('#ddlMyStoryFolders').val(activeFolderID);

    }

    function displayMoveSlideToMyStoryFolderPopUp(slideID) {

        var html = '<label id="lblSelectMyStoryDestinationFolder" class="settingLabel">' + locale.get('Select destination folder') + ':</label><select id="ddlMyStoryDestinationFolders" class="settingControl">';
        var options = '';

        for (var i = 0; i < myStory.Folders.length; i++) {
            options += '<option value="' + myStory.Folders[i].MyStoryFolderID + '">' + myStory.Folders[i].Name + '</option>';
        }

        html += options;
        html += '</select>';

        new DUIwindow2({
            title: '<h2>Copy slide to folder</h2>',
            width: 400,
            padding: 36,
            buttonsHeight: 50,
            buttons: [
                {
                    text: 'Cancel',
                    onClick: function () {
                        return false;
                    }
                },
                {
                    text: 'Copy',
                    focused: true,
                    onClick: function (event) {
                        var destinationFolderID = $('#ddlMyStoryDestinationFolders option:selected').val();
                        copySlideToMyStoryFolder(slideID, destinationFolderID);
                    }
                }
            ],
            html: html,
            modal: true,
            preWrapSpace: false,
        });
    }

    function displayRenameMyStoryFolderPopUp(folderID) {
        new DUIwindow2({
            title: '<h2>Rename folder</h2>',
            width: 400,
            padding: 36,
            buttonsHeight: 50,
            buttons: [
                {
                    text: 'Cancel',
                    onClick: function () {
                        return false;
                    }
                },
                {
                    text: 'Save',
                    focused: true,
                    onClick: function (event) {
                        var newName = $('#myStoryFolderNewName').val();
                        if (newName.length > 0) {
                            renameMyStoryFolder(newName, folderID);
                        } else {
                            $('#myStoryFolderNewName').css('border-color', '#e5a0b2').focus();
                            event.stopPropagation();
                        }
                    }
                }
            ],
            html: '<div class="settingItem"><label for="myStoryFolderNewName" class="settingLabel">New name:</label>' +
                    '<input id="myStoryFolderNewName" class="settingControl textbox"></input>' +
                    '</div>',
            modal: true,
            preWrapSpace: false,
            afterShow: function () {
                $('#myStoryFolderNewName').focus();
            }
        });
    }

    function displayRenameMyStorySlidePopUp(slideID) {
        new DUIwindow2({
            title: '<h2>Rename slide</h2>',
            width: 400,
            padding: 36,
            buttonsHeight: 50,
            buttons: [
                {
                    text: 'Cancel',
                    onClick: function () {
                        return false;
                    }
                },
                {
                    text: 'Save',
                    focused: true,
                    onClick: function (event) {
                        var newName = $('#myStorySlideNewName').val();
                        if (newName.length > 0) {
                            renameMyStorySlide(newName, slideID);
                        } else {
                            $('#myStorySlideNewName').css('border-color', '#e5a0b2').focus();
                            event.stopPropagation();
                        }
                    }
                }
            ],
            html: '<div class="settingItem"><label for="myStorySlideNewName" class="settingLabel">New name:</label>' +
                    '<input id="myStorySlideNewName" class="settingControl textbox"></input>' +
                    '</div>',
            modal: true,
            preWrapSpace: false,
            afterShow: function () {
                $('#myStorySlideNewName').focus();
            }
        });
    }

    function displayConfirmationPopup(message, executeOnConfirm) {
        
        new DUIwindow2({
            title: '',
            width: 400,
            height: 30,
            padding: 36,
            buttonsHeight: 50,
            buttons: [
                {
                    text: 'Cancel',

                    onClick: function () {
                        return false;
                    }
                },
                {
                    text: 'Delete',
                    focused: true,
                    onClick: function (e) {
                        executeOnConfirm();
                    }
                }
            ],
            html: '<div class="settingItem"><label">' + message + '</label></div>',
            modal: true,
            preWrapSpace: false           
        });
    }

    function saveFolderToMyStory(folderName) {
        var params = {
            method: 'SaveFolderToMyStory',
            message: 'Saving...',
            data: {
                folderName: folderName
            },
            successCallback: function (result) {
                myStory = JSON.parse(result);
                drawMyStoryAccordion();
            },
            service: 'MyStory'
        }

        Helpers.perfJSonCall(params);
    }

    function saveSlideToMyStoryFolder(slideName, folderID) {

        var optionalFilters = new Array();

        var slide = new Object();
        slide.MyStoryFolderID = folderID;
        slide.ReportID = Helpers.getReportID();
        slide.Name = slideName;
        slide.PositionInReport = Storyboard.LayoutDesigner.getCurrentPageNo();

        $(GeneralSettings.getSelectedSettings()).each(function () {
            if ($(this)[0].SelectedSettings.length > 0 &&
                $(this)[0].SettingType != "7") {
                var optionalFilter = new Object();
                optionalFilter.TypeID = $(this)[0].SettingType;
                optionalFilter.Selection = $(this)[0].SelectedSettings;
                optionalFilters.push(optionalFilter);
            }
        });

        slide.OptionalFilters = optionalFilters;

        var params = {
            method: 'SaveSlideToMyStoryFolder',
            message: 'Saving...',
            data: {
                slide: slide
            },
            successCallback: function (result) {
                myStory = JSON.parse(result);
                drawMyStoryAccordion();
            },
            service: 'MyStory'
        }

        Helpers.perfJSonCall(params);
    }

    function copySlideToMyStoryFolder(slideID, destinationFolderID) {

        var params = {
            method: 'CopySlideToMyStoryFolder',
            message: 'Copying...',
            data: {
                slideID: slideID,
                destinationFolderID: destinationFolderID
            },
            successCallback: function (result) {
                myStory = JSON.parse(result);
                drawMyStoryAccordion();
            },
            service: 'MyStory'
        }

        Helpers.perfJSonCall(params);
    }

    function renameMyStorySlide(newName, slideID) {
        var params = {
            method: 'RenameMyStorySlide',
            message: 'Renaming...',
            data: {
                slideID: slideID,
                newName: newName
            },
            successCallback: function (result) {
                myStory = JSON.parse(result);
                drawMyStoryAccordion();
            },
            service: 'MyStory'
        }

        Helpers.perfJSonCall(params);
    }

    function renameMyStoryFolder(newName, folderID) {
        var params = {
            method: 'RenameMyStoryFolder',
            message: 'Renaming...',
            data: {
                folderID: folderID,
                newName: newName
            },
            successCallback: function (result) {
                myStory = JSON.parse(result);
                drawMyStoryAccordion();
            },
            service: 'MyStory'
        }

        Helpers.perfJSonCall(params);
    }

    function deleteFolderFromMyStory(folderID) {

        var params = {
            method: 'DeleteFolderFromMyStory',
            message: 'Deleting...',
            data: {
                folderID: folderID
            },
            successCallback: function (result) {
                myStory = JSON.parse(result);
                drawMyStoryAccordion();
                handleInputElementsVisibility();
            },
            service: 'MyStory'
        }

        Helpers.perfJSonCall(params);
    }

    function deleteSlideFromMyStoryFolder(slideID) {

        var params = {
            method: 'DeleteSlideFromMyStoryFolder',
            message: 'Deleting...',
            data: {
                slideID: slideID
            },
            successCallback: function (result) {
                myStory = JSON.parse(result);
                drawMyStoryAccordion();
                handleInputElementsVisibility();
            },
            service: 'MyStory'
        }

        Helpers.perfJSonCall(params);
    }

    function updateSlidePositionsInMyStory() {

        var slides = new Array();

        $('.myStoryFolder').each(function () {
            var postionInFolder = 1;
            $(this).find('.myStorySlide').each(function () {
                var slide = new Object();
                slide.MyStorySlideID = $(this).attr('slideID');
                slide.PositionInMyStoryFolder = postionInFolder;
                slides.push(slide);
                postionInFolder++;
            });
        });

        var params = {
            method: 'UpdateSlidePositionsInMyStory',            
            data: {
                slidesFromGUI: slides
            },
            successCallback: function (result) {
                myStory = JSON.parse(result);

            },
            service: 'MyStory'
        }

        Helpers.perfJSonCall(params);
    }

    function openSelectedMyStorySlidesInNewWindow() {

        var selectedHFiltersParam = '';
        var selectedSlideIDs = '';

        if (Storyboard.HFilterLayout.hasHFilterNodes()) {
            var selectedHFilters = Storyboard.HFilterLayout.
                getSelectedIds("#hFilterTreeMyStory", true);
            selectedHFiltersParam = '&selectedmystoryhfilters=' + encodeURIComponent(selectedHFilters);
        }

        if ($('#accordionMyStory .ui-accordion-content-active').length > 0) {

            selectedSlideIDs = $('#accordionMyStory .ui-accordion-content-active .myStorySlideSelected').
                map(function () { return $(this).attr("slideid") }).get().join('|');

            if (selectedSlideIDs.length > 0) {
                $('body').find('.DUI-WINDOW-CLOSE').click();
                var page = document.URL + '&selectedMyStorySlideIDs=' + encodeURIComponent(selectedSlideIDs) + encodeURI(selectedHFiltersParam);
                var $dialog = $('<div></div>')
                               .html('<iframe style="border: 0px; " src="' + page +
                                    '" width="100%" height="100%"></iframe>')
                               .dialog({
                                   autoOpen: false,
                                   modal: true,
                                   height: 900,
                                   width: 1200,
                                   title: locale.get("My Story")
                               });
                $dialog.dialog('open');
            } else {
                displayInfoPopup('Please, select at least one slide', 2000);
            }
        }
    }

    function downloadMyStoryExport(exportType, fileType, methodName) {

        var selectedHFilters = [];
        var splitFilters = false;

        if (Storyboard.HFilterLayout.hasHFilterNodes()) {
            selectedHFilters = Storyboard.HFilterLayout.
                getSelectedIds("#hFilterTreeMyStory", true);
            splitFilters = $("#chkMyStorySplitFilter").attr("checked");
        }

        if ($('#accordionMyStory .ui-accordion-content-active').length > 0) {

            var selectedSlideIDs = $('#accordionMyStory .ui-accordion-content-active .myStorySlideSelected').
                map(function () { return $(this).attr("slideid") }).get().join('|');


            if (selectedSlideIDs.length > 0) {
                var layoutTemp = Storyboard.LayoutDesigner.getLayoutGrid();
                var currentMyStorySlideId = "";

                for (var i in layoutTemp.layoutElements) {
                    var currentMyStorySlidePos = Helpers.getLayoutElementSlideIndex(layoutTemp.layoutElements[i]);

                    if (selectedSlideIDs) {
                        currentMyStorySlideId = selectedSlideIDs.split("|")[currentMyStorySlidePos - 1];
                        layoutTemp.layoutElements[i].myStorySlideId = currentMyStorySlideId;
                    } else {
                        layoutTemp.layoutElements[i].myStorySlideId = -1;
                    }
                }
                var layoutGrid = Storyboard.LayoutDesigner.getLayoutGrid();
                var formats = Storyboard.Constants.documentFormats;
                var docFormat = formats.getDocFormat(layoutGrid.layoutType);
                var exportAsScreenshotQuality = 3;
                switch (parseInt(Storyboard.LayoutDesigner.imageQuality,10)) {
                case 5: exportAsScreenshotQuality = 3;
                    break;
                case 3: exportAsScreenshotQuality = 2;
                    break;
                case 1: exportAsScreenshotQuality = 1;
                    break;
               }

                var calldata = {
                    selectedHFilterNodes: selectedHFilters,
                    layout: layoutTemp,
                    splitFilters: splitFilters,
                    imageQuality: 5,
                    currentSlide: -1,
                    isAdmin: Storyboard.LayoutDesigner.isAdmin,
                    selectedMyStorySlideIDs: selectedSlideIDs,
                    fileName: $("#txtExportFileName").val() || "",
                    timeZoneOffset: new Date().getTimezoneOffset(),
                    sendEmailNotification: false,
                    allHFilters: false,
					exportAsScreenshot:Storyboard.LayoutDesigner.exportReportAsScreenshot,
                    qualityMultiplier:exportAsScreenshotQuality,
                    docFormatWidth: docFormat.layoutWidth,
                    docFormatHeight:docFormat.layoutHeight
                };

                var downloadParams = {
                    method: methodName,
                    data: calldata,
                    successCallback: function (exportItem) {
                        $("#myStoryExportedFiles img").remove();
                        $('#btnMyStoryGeneratePPT, #btnMyStoryGenerateExcel, #btnMyStoryViewSlides').removeAttr('disabled');

                        DownloadArea.bindExportItem(exportItem);
                    },
                    failCallback: function () {
                        downloadFailed();
                    },
                    fixCasing: true
                };

                if (exportType === 'PowerPoint') {
                    calldata.generalSettings = [];
                    calldata.exportType = 1;
                    calldata.respondentId = 0;
                } else if (exportType === 'Excel') {
                    calldata.settings = [];
                }
                $("#myStoryExportedFiles").append('<img src="images/spinner.gif"' +
                    ' style="width:12px;height:12px;padding-left:5px;" alt="' +
                    locale.get('Loading') + '"/>');
                $('#btnMyStoryGeneratePPT, #btnMyStoryGenerateExcel, #btnMyStoryViewSlides').attr('disabled', 'disabled');
                Helpers.perfJSonCall(downloadParams);
            } else {
                displayInfoPopup('Please, select at least one slide', 2000);
            }
        }
    }

    function downloadFailed() {
        $("#myStoryExportedFiles img").remove();
        $('#btnMyStoryGeneratePPT, #btnMyStoryGenerateExcel, #btnMyStoryViewSlides').removeAttr('disabled');
    }

    function SortByPosition(a, b) {
        var aPosition = a.PositionInMyStoryFolder;
        var bPosition = b.PositionInMyStoryFolder;
        return ((aPosition < bPosition) ? -1 : ((aPosition > bPosition) ? 1 : 0));
    }

    function SortByFolderID(a, b) {
        var aFolderID = a.MyStoryFolderID;
        var bFolderID = b.MyStoryFolderID;
        return ((aFolderID < bFolderID) ? -1 : ((aFolderID > bFolderID) ? 1 : 0));
    }

    function displayInfoPopup(message, duration) {

        var popUp = new DUIwindow({
            width: 250,
            height: 20,
            padding: 36,
            buttonsHeight: 50,
            cssClass: "DUI-WINDOW-2",
            buttons: [],
            html: message,
            modal: false,
            preWrapSpace: false
        });

        setTimeout(function () {
            $('#' + popUp.id).fadeOut('slow');
        }, duration);
    }

    function partial(func /*, 0..n args */) {
        var args = Array.prototype.slice.call(arguments, 1);
        return function () {
            var allArguments = args.concat(Array.prototype.slice.call(arguments));
            return func.apply(this, allArguments);
        };
    }    

})(window.Storyboard = (window.Storyboard || {}));